



























































































































































































import Vue, { PropType } from "vue";

export interface CloudPlansProps {
  action: string;
  lang: any;
  planName: any;
  planMap: any;
  priceMap: any;
  capacity_unit: string;
  capacityChoice: any;
  termChoice: any;
  defaultData: any;
  countryChoice: any;
  extendParams: any;
  currencyChoice: any;
  cloudTermsUrl: string;
  cloudAboutUrl: string;
  prevUrl: string;
  changeTermUrl: string;
  // PAY-4113 旧iPadEX版対応
  // 2026/1/19以降不要になるので適宜削除
  hasOldIpadExContract: boolean;
}

export interface CloudPlansData {
  capacity_unit: string;
  term_unit: string;
  currency_code: string;
  country_code: string;
  monthlyPrice: string;
  yearlyPrice: string;
}

export default Vue.extend({
  name: "vc-cloud-plans",

  data(): CloudPlansData {
    return {
      capacity_unit: this.defaultData.capacity_unit,
      term_unit: this.defaultData.term_unit,
      currency_code: this.defaultData.currency_code,
      country_code: this.defaultData.country_code,
      monthlyPrice: this.priceMap[
        this.planMap[this.defaultData.capacity_unit]["month"]
      ][this.defaultData.currency_code],
      yearlyPrice: this.priceMap[
        this.planMap[this.defaultData.capacity_unit]["year"]
      ][this.defaultData.currency_code]
    };
  },

  props: {
    lang: {
      type: Object as PropType<CloudPlansProps["lang"]>,
      default: () => {}
    },
    currencyChoice: {
      type: Array as PropType<CloudPlansProps["currencyChoice"]>,
      default: () => {}
    },
    capacityChoice: {
      type: Object as PropType<CloudPlansProps["capacityChoice"]>,
      default: () => {}
    },
    termChoice: {
      type: Object as PropType<CloudPlansProps["termChoice"]>,
      default: () => {}
    },
    planMap: {
      type: Object as PropType<CloudPlansProps["planMap"]>,
      default: () => {}
    },
    priceMap: {
      type: Object as PropType<CloudPlansProps["planMap"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<CloudPlansProps["defaultData"]>,
      default: () => {}
    },
    countryChoice: {
      type: Array as PropType<CloudPlansProps["countryChoice"]>,
      default: () => []
    },
    cloudTermsUrl: {
      type: String as PropType<CloudPlansProps["cloudTermsUrl"]>,
      default: ""
    },
    cloudAboutUrl: {
      type: String as PropType<CloudPlansProps["cloudAboutUrl"]>,
      default: ""
    },
    changeTermUrl: {
      type: String as PropType<CloudPlansProps["changeTermUrl"]>,
      default: ""
    },
    prevUrl: {
      type: String as PropType<CloudPlansProps["prevUrl"]>,
      default: ""
    },
    action: {
      type: String as PropType<CloudPlansProps["action"]>,
      default: ""
    },
    extendParams: {
      type: Object as PropType<CloudPlansProps["extendParams"]>,
      default: () => {}
    },
    hasOldIpadExContract: {
      type: Boolean as PropType<CloudPlansProps["hasOldIpadExContract"]>,
      default: false
    }
  },

  computed: {
    firstCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 2) return true;
      });
    },
    entryPaymentMethod(): string {
      return this.currency_code === "EUR" ||
        (this.currency_code === "JPY" && this.country_code === "JPN")
        ? this.$props.lang.proceed_to_purchase_button
        : this.$props.lang.card_input_button;
    }
  },

  methods: {
    submitPlan() {
      const formElement = this.$refs.formOffers as HTMLFormElement;
      const inputPlan = document.createElement("input");
      inputPlan.setAttribute("type", "hidden");
      inputPlan.setAttribute("name", "plan_code");
      inputPlan.setAttribute(
        "value",
        this.planMap[this.capacity_unit][this.term_unit]
      );
      formElement.appendChild(inputPlan);
      formElement.submit();
    },
    changePrice() {
      this.monthlyPrice = this.priceMap[
        this.planMap[this.capacity_unit]["month"]
      ][this.currency_code];
      this.yearlyPrice = this.priceMap[
        this.planMap[this.capacity_unit]["year"]
      ][this.currency_code];
    },
    isAppliedCapacity(index: string | number): boolean {
      return this.hasOldIpadExContract && index.toString() === "100";
    }
  }
});
